import i18n from "i18next"
import BrowserLanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

i18n
  .use(BrowserLanguageDetector)
  .use(initReactI18next)
  .init()

export { i18n }
